import { FunctionComponent } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { MobileHeader } from './MobileHeader';
import { Container } from './MobileLayout.style';

const MobileLayout: FunctionComponent = () => {
    return (
        <Container>
            <ScrollRestoration />
            <MobileHeader />
            <Outlet />
        </Container>
    );
};

export default MobileLayout;
